import pharmationLogo from 'assets/images/pharmation-logo.svg';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return (
    <svg
      viewBox="493 370 514 350"
      style={{ width: '52px', height: '52px', display: 'block' }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <image href={pharmationLogo} width="1500" height="1500" />
    </svg>
  );
}
